import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { MdEdit, MdOutlineDelete } from "react-icons/md";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FaWhatsapp, FaDownload } from "react-icons/fa";
import axios from "axios";
import edMantra from "../../services/edMantra";
import companyUpload from "../../assets/files/ATSCompany.xlsx";
import paginationFactory from "react-bootstrap-table2-paginator";
import { SiMicrosoftexcel } from "react-icons/si";
import ToolkitProvider, {
  Search,
  CSVExport,
  pagination,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import _ from "lodash";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import loadinggif from "../../assets/images/loading.gif";
import {
  FaFileDownload,
  FaFileExport,
  FaAddressCard,
  FaCloudUploadAlt,
  FaFilter,
} from "react-icons/fa";

const CollabrationTool = (props) => {
  const { data } = useSelector((state) => state?.currentSession?.userInfo);
  const [orgAgreeName, setorgAgreeName] = useState(null);
  const [showModal, setShow] = useState(false);
  const [showDocModal, setShowDoc] = useState(false);
  const [selectedRecruiterId, setRecruiterId] = useState(null);
  const [filters, setFilters] = useState({});
  const handleShow = (typeObj) => setShow(typeObj);
  const [allCompany, setAllCompany] = useState([]);
  const [companyRemarks, setCompanyRemarks] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [file, setFile] = useState({});
  const [allVacancy, setAllVacancy] = useState([]);
  const [newRemark, setNewRemark] = useState("");
  const fileInputRef = useRef();
  const [errors, setErrors] = useState({});
  const [toggle, setToggle] = useState(false);
  const [allRecruiters, setAllRecruiters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalCount, setTotalCount] = useState([]);
  const [totalLeads, setTotalLeads] = useState(0);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(50);
  const [orgRate, setOrgRate] = useState("");
  const [docUrl, setDocUrl] = useState("");
  const [company, setCompany] = useState({
    primaryPOCName: "",
    primaryPOCMobile: "",
    primaryPOCEmail: "",
    primaryPOCDesignation: "",
    secondaryPOCName: "",
    secondaryPOCMobile: "",
    companyStatus: "",
    followupDate: "",
    companyName: "",
    orgCategory: "",
    orgRate: "",
    orgAgree: "",
  });

  const validateForm = (data) => {
    let errors = {};

    // Company Name
    if (!data.companyName?.trim()) {
      errors.companyName = "Company Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(data.companyName.trim())) {
      errors.companyName = "Only characters are allowed in Company Name";
    }

    // Organization Category
    if (!data.orgCategory) {
      errors.orgCategory = "Please select an organization category";
    }

    // Primary POC Name
    if (!data.primaryPOCName?.trim()) {
      errors.primaryPOCName = "Primary POC Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(data.primaryPOCName.trim())) {
      errors.primaryPOCName =
        "Only characters are allowed in Primary POC Name";
    }

    // Primary POC Mobile
    if (!data.primaryPOCMobile?.trim()) {
      errors.primaryPOCMobile = "Primary POC Mobile number is required";
    } else if (!/^\d{10}$/.test(data.primaryPOCMobile.trim())) {
      errors.primaryPOCMobile =
        "Mobile number must be exactly 10 digits long";
    }

    // Primary POC Email
    if (!data.primaryPOCEmail?.trim()) {
      errors.primaryPOCEmail = "Primary POC Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.primaryPOCEmail.trim())) {
      errors.primaryPOCEmail = "Primary POC Email address is invalid";
    }

    // Primary POC Designation
    if (!data.primaryPOCDesignation?.trim()) {
      errors.primaryPOCDesignation =
        "Primary POC Designation is required";
    } else if (!/^[a-zA-Z\s]+$/.test(data.primaryPOCDesignation.trim())) {
      errors.primaryPOCDesignation =
        "Only characters are allowed in Primary POC Designation";
    }

    // Secondary POC Name
    if (!data.secondaryPOCName?.trim()) {
      errors.secondaryPOCName = "Owner Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(data.secondaryPOCName.trim())) {
      errors.secondaryPOCName =
        "Only characters are allowed in Owner Name";
    }

    // Secondary POC Mobile
    if (!data.secondaryPOCMobile?.trim()) {
      errors.secondaryPOCMobile =
        "Owner Contact number is required";
    } else if (!/^\d{10}$/.test(data.secondaryPOCMobile.trim())) {
      errors.secondaryPOCMobile =
        "Owner Contact number must be exactly 10 digits long";
    }

    // Company Status
    if (!data.companyStatus) {
      errors.companyStatus = "Please select a company status";
    }

    // Follow-up Date
    if (!data.followupDate) {
      errors.followupDate =
        "You cannot leave the next follow-up date blank";
    }

    return errors;
  };

  const handleClose = () => {
    setShow(false);
    setIsEdit(false);
    setCompany({
      primaryPOCName: "",
      primaryPOCMobile: "",
      primaryPOCEmail: "",
      primaryPOCDesignation: "",
      secondaryPOCName: "",
      secondaryPOCMobile: "",
      companyStatus: "",
      followupDate: "",
      companyName: "",
      orgCategory: "",
      orgRate: "",
      orgAgree: "",
    });
  };

  const handleBulkAssign = async (createdBy) => {
    try {
      const result = await edMantra.bulkAssign({
        createdBy,
        companyList: selectedRows,
      });
      if (result?.data?.errorCode === 0) {
        toast.success(result?.data.message);
        setRefresh(true);
      } else {
        toast.error(result?.data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleButtonClick = () => {
    fileInputRef?.current?.click();
  };

  const handleFileChange = (e, index) => {
    setFile(e.target.files[0]);
    setToggle(!toggle);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append("companyfile", file);
    formData.append("empId", data?.empId);
    try {
      const result = await edMantra.uploadCompany(formData);
      if (result.data.errorCode === 0) {
        setToggle(false);
        setRefresh(!refresh);
        toast(result?.data?.message);
        setFile({});
      }
    } catch (error) {
      // Default error message
      let errorMessage =
        "The phone number you entered is already registered. Please use a different phone number.";

      // Check for a specific error response from the backend (response.data.message)
      if (error?.response?.data?.message) {
        if (
          error.response.data.message.includes("Duplicate phone number found")
        ) {
          errorMessage =
            "The phone number you entered is already registered. Please use a different phone number.";
        }
      }

      toast.error(errorMessage);
      console.error("Error uploading files:", error);
    }
  };

  const handleOnchange = (value, valueField) => {
    setCompany((prev) => ({
      ...prev,
      [valueField]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [valueField]: "",
    }));

    if (valueField === "orgCategory") {
      setSelectedCategory(value);
    }

    if (valueField === "orgRate") {
      setOrgRate(value);
    }
  };

  const getAllCompany = async (page, sizePerPage, filters = {}) => {
    try {
      const queryParams = new URLSearchParams({
        page,
        limit: sizePerPage,
        empId: data?.empId,
        ...filters, // dynamic filters from UI
      });

      const response = await edMantra.getAllCompany(queryParams.toString());

      if (response?.data?.errorCode === 0) {
        setAllCompany(response.data.data);
        setTotalCount(response.data.totalRecords);
      } else {
        setAllCompany([]);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      setAllCompany([]);
    }
  };

  const pagination = paginationFactory({
    page,
    sizePerPage,
    totalSize: totalCount, // ✅ <- this MUST reflect total records in DB
    showTotal: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "500", value: 500 },
      { text: "1000", value: 1000 },
    ],
    onPageChange: (newPage) => setPage(newPage),
    onSizePerPageChange: (newSize, newPage) => {
      setSizePerPage(newSize);
      setPage(newPage); // ✅ Trigger fetchData on size change
    },
  });

  const handleTableChange = async (type, { page, sizePerPage, filters }) => {
    const parsedFilters = {};

    if (filters.companyName) {
      parsedFilters.companyName = filters.companyName.filterVal;
    }

    if (filters.primaryPOCMobile) {
      parsedFilters.primaryPOCMobile = filters.primaryPOCMobile.filterVal;
    }

    if (filters.primaryPOCEmail) {
      parsedFilters.primaryPOCEmail = filters.primaryPOCEmail.filterVal;
    }

    if (filters.orgCategory) {
      parsedFilters.orgCategory = filters.orgCategory.filterVal;
    }

    if (filters.orgRate) {
      parsedFilters.orgRate = filters.orgRate.filterVal;
    }

    if (filters.createdBy) {
      parsedFilters.createdBy = filters.createdBy.filterVal;
    }
    setFilters(parsedFilters);
    await getAllCompany(page, sizePerPage, parsedFilters);
  };

  const handleFiltering = (field, selectedValues) => {
    const updatedFilters = { ...filters, [field]: selectedValues };
    setFilters(updatedFilters);
    setPage(1);
    getAllCompany(1, sizePerPage, updatedFilters);
  };

  const handleUpdateCompany = async () => {
    const validationErrors = validateForm(company);

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      toast.error("Please correct the highlighted fields.");
      return;
    }
    const formData = new FormData();
    formData.append("companyId", company.companyId);
    formData.append("orgAgreeDoc", orgAgreeName);
    formData.append("primaryPOCName", company.primaryPOCName);
    formData.append("primaryPOCMobile", company.primaryPOCMobile);
    formData.append("primaryPOCEmail", company.primaryPOCEmail);
    formData.append("primaryPOCDesignation", company.primaryPOCDesignation);
    formData.append("secondaryPOCName", company.secondaryPOCName);
    formData.append("secondaryPOCMobile", company.secondaryPOCMobile);
    formData.append("companyStatus", company.companyStatus);
    formData.append("followupDate", company.followupDate);
    formData.append("companyName", company.companyName);
    formData.append("orgCategory", company.orgCategory);
    formData.append("orgRate", company.orgRate);
    formData.append("createdBy", data?.empId);
    formData.append("remarks", newRemark);

    if (orgAgreeName instanceof File) {
      formData.append("orgAgreeDoc", orgAgreeName);
    }

    try {
      // const response = await fetch("http://localhost:5000/api/updateCompanyById",
      const response = await fetch("https://mantraserp.com/api/updateCompanyById",

        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update company");
      }

      const result = await response.json();
      if (result?.errorCode === 0) {
        setShow(false);
        toast.success(result?.message);
        getAllCompany();
        setCompany({
          primaryPOCName: "",
          primaryPOCMobile: "",
          primaryPOCEmail: "",
          primaryPOCDesignation: "",
          secondaryPOCName: "",
          secondaryPOCMobile: "",
          companyStatus: "",
          followupDate: "",
          companyName: "",
          orgCategory: "",
          orgRate: "",
          orgAgreeName: "",
        });
      }
    } catch (error) {
      // Generic error handler
      toast.error("Failed to update company. Please try again.");
      console.error("Error updating company:", error);
    }
  };

  const getAllRecruiters = async () => {
    try {
      const res = await edMantra.getAllRecruiters();

      if (res?.data?.errorCode === 0 && Array.isArray(res.data.data)) {
        setAllRecruiters(res.data.data);
      } else {
        setAllRecruiters([]);
      }
    } catch (error) {
      console.error("Error fetching recruiters:", error);
      setAllRecruiters([]);
    }
  };

  useEffect(() => {
    getAllRecruiters(); // ✅ This will fetch recruiters on initial mount or refresh
  }, [refresh]);


  // Validate form first
  const handleSubmit = async () => {
    const validationErrors = validateForm(company);

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      toast.error("Please correct the highlighted fields.");
      return;
    }

    const formData = new FormData();

    formData.append("orgAgreeDoc", orgAgreeName || "");
    formData.append("primaryPOCName", company.primaryPOCName || "");
    formData.append("primaryPOCMobile", company.primaryPOCMobile || "");
    formData.append("primaryPOCEmail", company.primaryPOCEmail || "");
    formData.append(
      "primaryPOCDesignation",
      company.primaryPOCDesignation || ""
    );
    formData.append("secondaryPOCName", company.secondaryPOCName || "");
    formData.append("secondaryPOCMobile", company.secondaryPOCMobile || "");
    formData.append("companyStatus", company.companyStatus || "");
    formData.append("followupDate", company.followupDate || "");
    formData.append("companyName", company.companyName || "");
    formData.append("orgCategory", company.orgCategory || "");
    formData.append("orgRate", company.orgRate || "");
    formData.append("createdBy", data?.empId || "");
    formData.append("remarks", companyRemarks || "");

    try {
      const response = await fetch(
        //:5000/api/addCompany",
         "https://mantraserp.com/api/addCompany", // Production
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      // Handle API errors
      if (!response.ok) {
        throw new Error(result?.message || "Failed to add company");
      }

      if (result?.errorCode === 0) {
        toast.success(result?.message || "Company added successfully.");

        setShow(false);

        getAllCompany();

        // Reset form
        setCompany({
          primaryPOCName: "",
          primaryPOCMobile: "",
          primaryPOCEmail: "",
          primaryPOCDesignation: "",
          secondaryPOCName: "",
          secondaryPOCMobile: "",
          companyStatus: "",
          followupDate: "",
          companyName: "",
          orgCategory: "",
          orgRate: "",
          orgAgreeName: "",
        });
      } else {
        toast.error(result?.message || "Unable to add company.");
      }
    } catch (error) {
      console.error("Error adding company:", error);

      let errorMessage =
        "An unexpected error occurred. Please try again later.";

      const message = error?.message?.toLowerCase() || "";

      if (
        message.includes("phone must be unique") ||
        message.includes("phone already exists") ||
        message.includes("already registered")
      ) {
        errorMessage =
          "The phone number you entered is already registered. Please use a different phone number.";
      } else if (message.includes("network")) {
        errorMessage =
          "Unable to connect to the server. Please check your network and try again.";
      } else if (error?.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    }
  };



  const handleViewDoc = (docName) => {
    // Build a complete URL to the document
    const url = `${window.location.origin}/orguploads/${docName}`; // Adjust based on your deployment
    console.log("Document URL:", url); // Debug log to verify the URL
    setDocUrl(url);
    setShowDoc(true);
  };

  const handleCloseDoc = () => {
    setShowDoc(false);
    setDocUrl("");
  };

  const handleAadharDownlaod = async (fileName) => {
    try {
      if (!fileName) {
        console.error("No file to download");
        return;
      }

      const encodedFileName = encodeURIComponent(fileName); // Encode filename
      //const response = await axios.post('http://localhost:5000/api/orgdownload',
      const response = await axios.post(
        "https://mantraserp.com/api/orgdownload",
        { filename: encodedFileName },
        { responseType: "blob" } // Important for binary data
      );

      // Create a URL for the blob and trigger a download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // Set the default file name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const handleEdit = async (row) => {
    try {
      setIsLoading(true);

      console.log("Editing row:", row);
      console.log("Company ID:", row.companyId);

      const response = await edMantra.getCompanyById({
        companyId: row.companyId,
      });

      console.log("Get Company Response:", response.data);

      if (response?.data?.errorCode === 0) {
        const companyData = response.data.data.company;
        const remarksData = response.data.data.remarks || [];

        console.log("Company:", companyData);
        console.log("Remarks:", remarksData);

        setCompany({
          ...companyData,
          followupDate: companyData.followupDate
            ? companyData.followupDate.split("T")[0]
            : "",
        });

        setCompanyRemarks(remarksData);

        setSelectedCategory(companyData.orgCategory || "");
        setOrgRate(companyData.orgRate || "");

        setorgAgreeName(null);

        setIsEdit(true);
        setShow(true);
      } else {
        toast.error(
          response?.data?.message || "Unable to fetch company details"
        );
      }
    } catch (error) {
      console.error(
        "Error fetching company details:",
        error?.response?.data || error
      );

      toast.error(
        error?.response?.data?.message ||
        "Unable to fetch company details"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const openWhatsApp = async (primaryPOCMobile) => {
    try {
      let phone = primaryPOCMobile.replace(/\D/g, ""); // Remove non-numeric characters
      if (!phone.startsWith("91")) {
        phone = "91" + phone; // Ensure country code is included
      }
      const whatsappUrl = `https://wa.me/${phone}`;
      window.open(whatsappUrl, "_blank");
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (companyId) => {
    try {
      const formData = { companyId }; // Ensure formData is an object with companyId
      const res = await edMantra.deleteCompanyById(formData);

      if (res.data?.errorCode === 0) {
        toast.success(res?.data?.message);
        getAllCompany();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // const handleBulkDelete = async () => {
  //   try {
  //     // Ensure selectedRows is a proper array
  //     const companyArray = Array.isArray(selectedRows)
  //       ? selectedRows
  //       : Object.values(selectedRows); // fallback if selectedRows is an object

  //     console.log("Sending to API:", companyArray);

  //     const result = await edMantra.deleteBulkCompany({
  //       company: companyArray,
  //     });

  //     if (result.data.errorCode === 0) {
  //       toast.success(result.data.message);
  //       // Optional: refresh data or reset selection
  //     } else {
  //       toast.error(result.data.message || "Something went wrong");
  //     }
  //   } catch (error) {
  //     if (error.response && error.response.data) {
  //       toast.error(error.response.data.message || "Internal server error");
  //     } else {
  //       toast.error("Internal server error");
  //     }
  //     console.error("Error in handleBulkDelete:", error);
  //   }
  // };

  const handleBulkArchive = async () => {
    try {
      // Ensure selectedRows is a proper array
      const companyArray = Array.isArray(selectedRows)
        ? selectedRows
        : Object.values(selectedRows); // fallback if selectedRows is an object

      console.log("Sending to API:", companyArray);

      const result = await edMantra.deadbulkCompany({
        company: companyArray,
      });

      if (result.data.errorCode === 0) {
        toast.success(result.data.message);
        // Optional: refresh data or reset selection
      } else {
        toast.error(result.data.message || "Something went wrong");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message || "Internal server error");
      } else {
        toast.error("Internal server error");
      }
      console.error("Error in handleBulkDelete:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getAllCompany(page, sizePerPage); // ✅ include correct pagination
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [refresh, page, sizePerPage]);

  const { ExportCSVButton } = CSVExport;
  const columns = [
    {
      dataField: "companyName",
      text: "Company Name",
      sort: true,
      filter: textFilter(),
      headerStyle: { minWidth: "120px" },
    },
    {
      dataField: "primaryPOCMobile",
      text: "Primary POC Number",
      sort: true,
      filter: textFilter(),
      headerStyle: { minWidth: "120px" },
    },

    {
      dataField: "primaryPOCEmail",
      text: "Primary POC Email",
      filter: textFilter(),
      headerStyle: { minWidth: "120px" },
    },
    {
      dataField: "companyStatus",
      text: "Status",
      sort: true,
      filter: textFilter(),
      headerStyle: { minWidth: "120px" },
    },
    {
      dataField: "orgCategory",
      text: "Org. Category",
      sort: true,
      filter: textFilter(),
      headerStyle: { minWidth: "120px" },
    },
    {
      dataField: "orgRate",
      text: "Org. Fees",
      sort: true,
      filter: textFilter(),
      headerStyle: { minWidth: "120px" },
    },

    {
      dataField: "orgAgree",
      text: "Org. Agreement",
      sort: true,
      filter: textFilter(),
      formatter: (cell, row) => (
        <div className="d-flex">
          <a href="#" onClick={() => handleAadharDownlaod(row.orgAgree)}>
            {row.orgAgree} | <FaDownload />
          </a>
          {/* <span style={{ margin: '0 10px' }}>|</span>
          <a href="#" onClick={() => handleViewDoc(row.orgAgree)}>View</a> */}
        </div>
      ),
    },
    {
      dataField: "followupDate",
      text: "Follow-up Date",
      sort: true,
      filter: textFilter(),
      headerStyle: { minWidth: "120px" },
    },
    {
      dataField: "createdBy",
      text: "Recruitment Manager",
      sort: true,
      filter: selectFilter({
        options:
          allRecruiters.length > 0
            ? allRecruiters.map((emp) => ({
              value: emp.empId,
              label: `${emp.fname} ${emp.lname}`,
            }))
            : [],
        placeholder: "Select or Search by Name",
      }),
      formatter: (cell, row) => {
        const itemObj = allRecruiters.find(
          (emp) => emp.empId === row.createdBy
        );
        return itemObj
          ? `${itemObj?.fname} ${itemObj?.lname}`
          : loading
            ? "Loading..."
            : "Data not available";
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="d-flex">
          <FaWhatsapp
            onClick={() => openWhatsApp(row?.primaryPOCMobile)}
            size={20}
            color="limegreen"
          />

          <MdEdit
            size={25}
            color="black"
            style={{ cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(row)}
          />
          {(data?.role?.roleName === "SuperAdmin" ||
            data?.role?.roleName === "AdminEM") && (
              <MdOutlineDelete
                size={25}
                color="red"
                style={{ cursor: "pointer" }}
                onClick={() => handleDelete(row.companyId)}
              />
            )}
        </div>
      ),
    },
  ];

  const mergedVacancies = allVacancy.map((vacancy) => {
    const recruiter = allRecruiters.find(
      (recruiter) => String(recruiter.empId) === String(vacancy.createdBy)
    );

    // Log recruiter for debugging
    console.log("Recruiter Found:", recruiter);

    return {
      ...vacancy,
      name: recruiter
        ? `${recruiter.fname || ""} ${recruiter.lname || ""}`.trim()
        : "Unknown",
    };
  });

  console.log("Merged Vacancies:", mergedVacancies);

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    bgcolor: "red",
  };

  // Function to handle row selection
  const handleRowSelect = (row, isSelected) => {
    setSelectedRows([...selectedRows, row]);
  };
  console.log(selectedRows);

  // Function to handle row selection for all rows
  const handleRowSelectAll = (isSelected, rows) => {
    // Update selectedRows state when all rows are selected or deselected
    console.log(rows);
    if (isSelected) {
      setSelectedRows(rows);
    } else {
      setSelectedRows([]);
    }
  };

  useEffect(() => {
    getAllCompany(page, sizePerPage); // <- important!
  }, [refresh, page, sizePerPage]);

  console.log(allRecruiters, "Badiya si string ");

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 card border-0">
            <p className="fs-3 fw-normal typed-text">Manage Company</p>
          </div>

          <div className="card col-md-4 col-sm-12 border-0">
            <div className="d-flex flex-wrap align-items-center">
              {toggle ? (
                <button
                  type="button"
                  className="btn btn-warning btn-sm p-2"
                  onClick={handleUpload}
                >
                  <FaCloudUploadAlt color={"black"} size={20} /> Upload
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-warning btn-sm p-2"
                    onClick={handleButtonClick}
                  >
                    <FaFileDownload color={"black"} size={20} />{" "}
                    <span className="">Import</span>
                  </button>

                  <a
                    href={companyUpload}
                    download
                    className="btn btn-warning btn-sm m-1"
                  >
                    <FaFileExport color={"black"} size={20} /> Sample File
                  </a>

                  <button
                    type="button"
                    className="btn btn-warning btn-sm"
                    onClick={() => handleShow(true)}
                  >
                    <FaAddressCard color={"black"} size={20} /> Add Company
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="card col-md-4 col-sm-12 border-0 mt-2">
            {data?.role?.roleName === "SuperAdmin" ||
              data?.role?.roleName === "AdminEM" ? (
              <select
                className="form-select border-1 mb-2"
                aria-label="Default select example"
                onChange={(e) => {
                  // Handle the update action when "Dead Lead" is selected
                  if (e.target.value === "Dead Company") {
                    handleBulkArchive();
                  }
                }}
              >
                <option>Select Action</option>
                <option value="Dead Company">Archive Company</option>
              </select>
            ) : null}

            {data?.role?.roleName === "SuperAdmin" ||
              data?.role?.roleName === "AdminEM" ? (
              <>
                <select
                  className="form-select border-1 mb-2"
                  aria-label="Default select example"
                  onChange={(e) => handleBulkAssign(e.target.value)}
                  required
                >
                  <option value="Not Assigned">
                    Select Recruitment Manager
                  </option>

                  {allRecruiters.map((item, index) => (
                    <option key={index} value={item.empId}>
                      {`${item.fname} ${item.lname}`}
                    </option>
                  ))}
                </select>
              </>
            ) : null}
          </div>

          <div className="card col-md-12 border-0">
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <img src={loadinggif} alt="Loading" />
              </div>
            ) : (
              <ToolkitProvider
                keyField="companyId"
                data={allCompany}
                columns={columns}
                exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                search
              >
                {(props) => (
                  <div>
                    {(data?.role?.roleName === "SuperAdmin" ||
                      data?.role?.roleName === "AdminEM") && (
                        <ExportCSVButton
                          className="btn btn-success btn-sm mb-2 float-end"
                          {...(props.csvProps || {})}
                          filename="MantrasERP_ATS_Companies_Report.csv"
                        >
                          <SiMicrosoftexcel />
                          Export Record
                        </ExportCSVButton>
                      )}
                    <div className="table-responsive cus-table">
                      <BootstrapTable
                        {...props.baseProps}
                        selectedRows={selectedRows}
                        bootstrap4
                        keyField="companyId"
                        data={allCompany}
                        columns={columns}
                        striped
                        hover
                        condensed
                        filter={filterFactory()}
                        remote={{ pagination: true }}
                        pagination={pagination}
                        onTableChange={handleTableChange}
                        selectRow={{
                          mode: "checkbox",
                          clickToSelect: true,
                          onSelect: handleRowSelect,
                          onSelectAll: handleRowSelectAll,
                        }}
                        filterPosition="top"
                      />
                    </div>

                    <Modal
                      show={showDocModal}
                      onHide={handleCloseDoc}
                      size="lg"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>View Document</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {docUrl.endsWith(".pdf") ? (
                          <iframe src={docUrl} width="100%" height="500px" />
                        ) : (
                          <img
                            src={docUrl}
                            alt="Document Preview"
                            style={{ width: "100%" }}
                          />
                        )}
                      </Modal.Body>
                    </Modal>
                  </div>
                )}
              </ToolkitProvider>
            )}
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {/* {showModal?.state && showModal?.type === "ADD_COMPANY" ? (
              <p>Company Registration Form</p>
            ) : (
              <p>Vacancy Form</p>
            )} */}

            <p>Edit Company</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {/* {isEdit ? ( */}
          <>
            <h6 className="custom-h6">Organization Information</h6>
            <div className="row">
              <div className="col-md-6">
                <p className="mb-0 fs-6"> Comapny Name</p>
                <input
                  placeholder="Company Name"
                  className={`form-control py-0 ${errors.companyName ? "is-invalid" : ""
                    }`}
                  type="text"
                  value={company.companyName}
                  onChange={(e) =>
                    handleOnchange(e.target.value, "companyName")
                  }
                />

                {errors.companyName && (
                  <div className="text-danger small mt-1">
                    {errors.companyName}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <p className="mb-0 fs-6">Category</p>
                <select
                  name=""
                  id=""
                  className="form-control"
                  value={company.orgCategory}
                  onChange={(e) =>
                    handleOnchange(e.target.value, "orgCategory")
                  }
                >
                  <option value={null}>Select Category</option>
                  <option value={"Silver"}>Silver</option>
                  <option value={"Platinum"}>Platinum</option>
                  <option value="Agreement Pending">Agreement Pending</option>
                </select>
              </div>
              {(selectedCategory === "Platinum" ||
                selectedCategory === "Silver") && (
                  <div className="row">
                    <div className="form-group col-md-12">
                      <label>Rate</label>
                      <input
                        type="text"
                        className="form-control"
                        value={company.orgRate}
                        placeholder="Agreemented Rate"
                        onChange={(e) =>
                          handleOnchange(e.target.value, "orgRate")
                        }
                      />
                    </div>
                  </div>
                )}

              {(selectedCategory === "Platinum" ||
                selectedCategory === "Silver") && (
                  <div className="col-md-12 mt-2">
                    <p className="mb-0 fs-6">Org. Agreement</p>
                    <input
                      className="form-control py-0"
                      type="file"
                      accept=".pdf,.doc,.docs"
                      name="orgAgreeDoc"
                      onChange={(e) => setorgAgreeName(e.target.files[0])}
                    />
                  </div>
                )}
            </div>

            <h6 className="custom-h6 mt-5">Primary Point of Contact</h6>
            <div className="row">
              <div className="col-md-4">
                <p className="mb-0 fs-6"> Name</p>
                <input
                  placeholder="Name"
                  className={`form-control py-0 ${errors.primaryPOCName ? "is-invalid" : ""
                    }`}
                  type="text"
                  value={company.primaryPOCName}
                  onChange={(e) =>
                    handleOnchange(e.target.value, "primaryPOCName")
                  }
                />

                {errors.primaryPOCName && (
                  <div className="text-danger small mt-1">
                    {errors.primaryPOCName}
                  </div>
                )}
              </div>
              <div className="col-md-4">
                <p className="mb-0 fs-6">Contact No</p>
                <input
                  placeholder="Contact Number"
                  className={`form-control py-0 ${errors.primaryPOCMobile ? "is-invalid" : ""
                    }`}
                  type="tel"
                  maxLength="10"
                  value={company.primaryPOCMobile}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (/^\d{0,10}$/.test(value)) {
                      handleOnchange(value, "primaryPOCMobile");
                    }
                  }}
                />

                {errors.primaryPOCMobile && (
                  <div className="text-danger small mt-1">
                    {errors.primaryPOCMobile}
                  </div>
                )}
              </div>
              <div className="col-md-4">
                <p className="mb-0 fs-6"> Email Address</p>
                <input
                  placeholder="Enter Email Address"
                  className={`form-control py-0 ${errors.primaryPOCEmail ? "is-invalid" : ""
                    }`}
                  type="email"
                  value={company.primaryPOCEmail}
                  onChange={(e) =>
                    handleOnchange(e.target.value, "primaryPOCEmail")
                  }
                />

                {errors.primaryPOCEmail && (
                  <div className="text-danger small mt-1">
                    {errors.primaryPOCEmail}
                  </div>
                )}
              </div>
              <div className="col-md-12 mt-2">
                <p className="mb-0 fs-6"> Designation</p>
                <input
                  placeholder="Designation"
                  className={`form-control py-0 ${errors.primaryPOCDesignation ? "is-invalid" : ""
                    }`}
                  type="text"
                  value={company.primaryPOCDesignation}
                  onChange={(e) =>
                    handleOnchange(e.target.value, "primaryPOCDesignation")
                  }
                />
              </div>
            </div>

            <h6 className="custom-h6 mt-5">Owner's Details</h6>
            <div className="row">
              <div className="col-md-4">
                <p className="mb-0 fs-6"> Name</p>
                <input
                  placeholder="Name"
                  className={`form-control py-0 ${errors.secondaryPOCName ? "is-invalid" : ""
                    }`}
                  type="text"
                  value={company.secondaryPOCName}
                  onChange={(e) =>
                    handleOnchange(e.target.value, "secondaryPOCName")
                  }
                />
              </div>
              <div className="col-md-4">
                <p className="mb-0 fs-6">Contact No</p>
                <input
                  placeholder="Contact Number"
                  className={`form-control py-0 ${errors.secondaryPOCMobile ? "is-invalid" : ""
                    }`}
                  type="tel"
                  maxLength="10"
                  value={company.secondaryPOCMobile}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (/^\d{0,10}$/.test(value)) {
                      handleOnchange(value, "secondaryPOCMobile");
                    }
                  }}
                />

                {errors.secondaryPOCMobile && (
                  <div className="text-danger small mt-1">
                    {errors.secondaryPOCMobile}
                  </div>
                )}
              </div>
              <div className="col-md-4">
                <p className="mb-0 fs-6">Company Status</p>
                <select
                  className={`form-control ${errors.companyStatus ? "is-invalid" : ""
                    }`}
                  value={company.companyStatus}
                  onChange={(e) =>
                    handleOnchange(e.target.value, "companyStatus")
                  }
                >
                  <option value="">Select Company Status</option>
                  <option value="Live Company">Live Company</option>
                  <option value="Dead Company">Dead Company</option>
                </select>

                {errors.companyStatus && (
                  <div className="text-danger small mt-1">
                    {errors.companyStatus}
                  </div>
                )}
              </div>
              <div className="col-md-12 mt-2">
                <p className="mb-0 fs-6">Follow-up Date</p>

                <input
                  className={`form-control py-0 ${errors.followupDate ? "is-invalid" : ""
                    }`}
                  type="date"
                  value={company.followupDate || ""}
                  onChange={(e) =>
                    handleOnchange(e.target.value, "followupDate")
                  }
                />

                {errors.followupDate && (
                  <div className="text-danger small mt-1">
                    {errors.followupDate}
                  </div>
                )}
              </div>
              <div className="col-md-12 mt-2">
                <p className="mb-0 fs-6">Remarks</p>

                <textarea
                  className={`form-control ${errors.newRemark ? "is-invalid" : ""
                    }`}
                  rows="3"
                  placeholder="Enter new remark"
                  value={newRemark}
                  onChange={(e) => setNewRemark(e.target.value)}
                />
                {errors.newRemark && (
                  <div className="text-danger small mt-1">
                    {errors.newRemark}
                  </div>
                )}
              </div>
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} size="sm">
            Close
          </Button>
          {
            isEdit ? (
              // showModal?.state && showModal?.type === "ADD_COMPANY" ? (
              <Button variant="primary" onClick={handleUpdateCompany} size="sm">
                Update Company
              </Button>
            ) : (
              <Button variant="primary" onClick={handleSubmit} size="sm">
                Add Company
              </Button>
            )
            //     <Button variant="primary" onClick={handleUpdateCompany} size="sm">
            //       Update Vacancy
            //     </Button>
            //   )
            // ) : showModal?.state && showModal?.type === "ADD_COMPANY" ? (
            //   <Button variant="primary" onClick={handleSubmit} size="sm">
            //     Add Company
            //   </Button>
            // ) : (
            //   <Button variant="primary" onClick={handleVacancySubmit} size="sm">
            //     Add Vacancy
            //   </Button>
          }
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CollabrationTool;
